<!--
 * @Date: 2020-05-28 10:38:21
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-28 11:00:30
 * @FilePath: /xy-pc/src/views/agreement/agreement.vue
--> 
<template>
  <div style="padding:20px">
    <el-card>
      <div  class="ritchHtml" v-html="valueHtml"></div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valueHtml: "未配置"
    };
  },
  created() {
    if (this.$route.query.name) {
      this.getValue(this.$route.query.name);
    }
  },

  methods: {
    getValue(name) {
      this.$http({
        url: "/api/v1/configs/value",
        method: "get",
        params: { name: name }
      }).then(res => {
        if (res.status == 200) {
          if (res.data.value) {
            this.valueHtml = res.data.value;
          }
        }
      });
    }
  }
};
</script>

<style>
</style>